import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { Layout } from '@/modules/shared/layouts/layout'
import { PromotionVisitFormInterface } from '../interfaces/promotion-visit-form.interface'
import { usePromotionVisit } from '../hooks/use-promotion-visit.hook'
import { usePromotionVisitForm } from '../hooks/use-promotion-visit-form.hook'

export function PromotionVisitFormContainer() {
	const navigate = useNavigate()
	const promotionVisitHook = usePromotionVisit()
	const { id } = useParams<{ id: string }>()
	const location = useLocation()

	const isViewMode = location.pathname.includes('/visualizar')
	const isEditMode = !!id && !isViewMode

	const getPageTitle = () => {
		if (isViewMode && id) {
			return `Visualização de Visita #${id}`
		} else if (isEditMode) {
			return `Edição de Visita #${id}`
		} else {
			return "Nova Visita"
		}
	}

	const navigateBack = () => {
		navigate('/visitas')
	}

	const formHook = usePromotionVisitForm({
		getVisit: promotionVisitHook.getVisit,
		saveVisit: promotionVisitHook.saveVisit,
		isLoading: promotionVisitHook.isLoading
	})

	return (
		<Layout
			pageTitle={getPageTitle()}
			handleGoBack={promotionVisitHook.handlegoBack}
		>
			<PromotionVisitFormInterface
				{...formHook}
				isEditMode={isEditMode}
				isViewOnly={isViewMode}
				navigateBack={navigateBack}
			/>
		</Layout>
	)
}